const pagesTranslations = {
    ru: {
        centers_title: 'Падел центры',
        centers_name: 'Название',
        centers_city: 'Город',
        centers_address: 'Адрес',
        centers_courts: 'Количество кортов',
        contacts: 'Контакты',
        phone_number: 'Номер телефона',
        instagram: 'Инстаграм',
        events_title: 'События',
        events_name: 'Название',
        events_period: 'Период',
        events_all_months: 'Все месяцы',
        share_event: 'Поделитесь этим событием'
    },
    kk: {
        centers_title: 'Падел орталықтары',
        centers_name: 'Атауы',
        centers_city: 'Қала',
        centers_address: 'Мекенжай',
        centers_courts: 'Корттар саны',
        contacts: 'Байланыс',
        phone_number: 'Телефон нөмірі',
        instagram: 'Instagram',
        events_title: 'Іс-шаралар',
        events_name: 'Атауы',
        events_period: 'Кезең',
        events_all_months: 'Барлық айлар',
        share_event: 'Осы іс-шарамен бөлісіңіз'
    },
    en: {
        centers_title: 'Padel centers',
        centers_name: 'Name',
        centers_city: 'City',
        centers_address: 'Address',
        centers_courts: 'Number of courts',
        contacts: 'Contacts',
        phone_number: 'Phone number',
        instagram: 'Instagram',
        events_title: 'Events',
        events_name: 'Name',
        events_period: 'Period',
        events_all_months: 'All months',
        share_event: 'Share this event'
    }
};

export default pagesTranslations;
